<template>
  <div class="express-vue-insurance" :class="setSiteSpecific.isStudent && 'student-policy'">
    <router-view id="insurance"  :defaultSite='this.setSiteSpecific' />
  </div>
</template>

<script>
export default {
  name: "tf-vue-insurance",
  computed: {
    setSiteSpecific () {
      const hostname = window.location.hostname
      const elements = hostname.toLowerCase().split('.')
      const domain = elements[elements.length - 1]
      const year = new Date().getFullYear()
      const isStudent = window.location.pathname.includes('backpacker-insurance')

      let defaultSite = {}
      if (hostname.includes('local')) {
        defaultSite = {
        symbol: '\u00A3',
        name: 'GBP',
        telephone: '020 7408 9005',
        domain: 'com',
        nedstat: 'UK',
        policy: 'ukpolicy' + year + 'v3.pdf',
        ipid: 'ukipid' + year + 'v4.pdf',
        studentpolicy : 'ukpolicy' + year + 'v2tta.pdf',
        studentipid : 'ukipid' + year + 'v2tta.pdf',
        isStudent : isStudent
        }
      } else if (domain === 'ie') {
        defaultSite = {
        symbol: '\u20AC',
        name: 'EUR',
        telephone: '01 702 9102',
        domain: 'ie',
        nedstat: 'IE',
        policy: 'iepolicy' + year + 'v1.pdf',
        ipid: 'ieipid' + year + 'v1.pdf',
        studentpolicy : 'iepolicy' + year + 'v1tta.pdf',
        studentipid : 'ieipid' + year + 'v1tta.pdf',
        isStudent : isStudent
        }
      } else if (domain === 'scot') {
        defaultSite = {
        symbol: '\u00A3',
        name: 'GBP',
        telephone: '020 7408 9005',
        domain: 'scot',
        nedstat: 'SCO',
        policy: 'ukpolicy' + year + 'v3.pdf',
        ipid: 'ukipid' + year + 'v4.pdf',
        studentpolicy : 'ukpolicy' + year + 'v2tta.pdf',
        studentipid : 'ukipid' + year + 'v2tta.pdf',
        isStudent : isStudent
        }
      }
        else {
        defaultSite = {
        symbol: '\u00A3',
        name: 'GBP',
        telephone: '020 7408 9005',
        domain: 'com',
        nedstat: 'UK',
        policy: 'ukpolicy' + year + 'v3.pdf',
        ipid: 'ukipid' + year + 'v4.pdf',
        studentpolicy : 'ukpolicy' + year + 'v2tta.pdf',
        studentipid : 'ukipid' + year + 'v2tta.pdf',
        isStudent : isStudent
        }
      }
      return defaultSite
    },
  },
};
</script>

<style lang="scss">
@import url('https://cdn.trailfinders.com/static/codesource/fonts/tficons/iconstyle.css');
.express-vue-insurance {
  background-color: #fff;
  padding: 10px;
}
.tf-vue-tag { 
  position: absolute;
  top: 45px;
  right: -5px;
  display: table;
  height: 40px;
  width: 50px;
  padding: 0 5px 0 10px;
  background-color: #fcb134;
  font-size: 11px;
  font-weight: bold;
  border-radius: 0 5px 5px 0;
}
.tf-vue-tag::before {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-right: 15px solid #fcb134;
  position: absolute;
  top: 50%;
  margin-top: -20px;
  right: 100%;
  z-index: 1;
}
.tf-vue-tag-child {
  top: 70px;
}
.tf-vue-tag-selected { 
  position: absolute;
  top: 45px;
  left: -5px;
  display: table;
  height: 40px;
  width: 50px;
  padding: 0 5px 0 10px;
  background-color: #0d0903;
  font-size: 11px;
  font-weight: bold;
  border-radius: 5px 0 0 5px;
}
.tf-vue-tag-selected::before {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 15px solid #0d0903;
  position: absolute;
  top: 50%;
  margin-top: -20px;
  left: 100%;
  z-index: 1;
}
.tf-vue-tag-selected-child {
  top: 70px;
}
.tf-vue-bg-grey-darker {
  background-color: #bbbbbb;
}
.tf-vue-bg-grey-dark {
  background-color: #e7e7e7;
}
.tf-vue-bg-grey-light {
  background-color: #f2f2f2;
}
.tf-vue-is-invalid {
  border: 1px solid red;
}
.tf-vue-cover {
  background-color: #fcb134;
  color: #fff;
  padding: 5px;
  font-size: 10px;
}
.tf-vue-list-unstyled {
  list-style: none;
  margin: 0;
  padding: 0;
}

input[type=text]{
    border:none;
    border-bottom: 1px solid rgb(21, 21, 21);
    background-color: rgba(239, 236, 230, 0);
    font-family: inherit;
  }
select {
  background-color: rgba(0,0,0,0)
 }
  

// student styles
.student-policy {
  background-image: url(https://cdn.trailfinders.com/machu_pichu_bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;

@media screen and (max-width:2000px){
  .xl-font {
    font-size: 4em;
  line-height: 0.8;
  font-weight: 600;
  text-shadow: -6px -6px #dd7d7d;
  }
}
@media screen and (min-width:2001px){
  .xl-font {
    font-size: 6em;
  line-height: 0.8;
  font-weight: 600;
  text-shadow: -6px -6px #dd7d7d;
  }
}


 .text-shadow {
  text-shadow: -1px 1px  #ffffff;
 }
 .hover:hover {
  cursor: pointer;
 }
}


</style>
